import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Logo from "../../assets/images/Logo.svg";
import Modal from "react-bootstrap/Modal";
import { handleApiCall } from "../../apis";
import { endpoint } from "../../utils/endpoints";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import SignupSlider from "../../Components/Signupslider/index";

const IconCheck = require("../../assets/image/icon-check.png");
const ForgotPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState();
  const [forget, setForgot] = useState();
  const [verification, setVerification] = useState(false);
  const VerificationShow = () => setVerification(true);
  const [bt, setBt] = useState(true);
  const dispatch = useDispatch();
  const handleClose = () => {
    setForgot(false);
    setVerification(false);
  };
  const handleforget = async (e) => {
    e.preventDefault();
    setBt(false);
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    try {
      if (!email) {
        setEmailError("Please Enter Email");
        return;
      } else if (!emailRegex.test(email)) {
        setEmailError("Please Enter a Valid Email");
        return;
      }
      const response = await handleApiCall(
        "post",
        `${endpoint.forgotPassword}`,
        {
          email: email,
        }
      );
      console.log(response);
      if (response) {
        setBt(true);
        if (response?.data?.code === 200) {
          toast.success("Otp  Send Successfully.", "", "success");

          navigate("/otpverification", {
            state: { email, type: "forgotPassword" },
          });
        } else {
          toast.error(response?.response?.data?.errorMessage);
        }
      }
    } catch (error) {
      console.log("Error:", error);
      // alert("Something went wrong");
      setBt(true);
    }
  };
  return (
    <>
      <div className="w-full md:flex block">
        <div class="md:w-6/12 w-full">
          <div className="flex items-center justify-center h-screen">
            <div className="block md:w-80 w-10/12">
              <img src="images/black-logo.svg" alt="" className="mx-auto" />
              <h1 className="text-2xl text-black text-center font-BonaNovaRegular py-2">
                Forgot Password
              </h1>
              <img
                src="/images/progress-start.png"
                alt=""
                className="w-40 mx-auto py-2"
              />

              <form className="custom_form">
                <div className="form-group">
                  <div className="pos-r">
                    <div className="text-[13px] font-Montserratmedium text-[#2B2B2B] opacity-50 mb-1">
                      Enter registered email
                    </div>
                    <input
                      type="email"
                      // className="form-control cf_input rounded-0"
                      className="mt-1 w-full px-3 py-2 border !border-inputfieldborder pr-10 bg-white outline-none text-sm font-Montserratmedium text-forgetpassword"
                      id="email"
                      value={email}
                      onChange={(e) => {
                        setEmailError("");
                        setEmail(e.target.value);
                      }}
                    />
                  </div>
                  <div className="m-3">
                    <h6 className="text-start text-red-600 font-normal">
                      {emailError}
                    </h6>
                  </div>
                </div>
                <div className="form-group text-end"></div>
                <button
                  disabled={!bt}
                  onClick={(e) => handleforget(e)}
                  className=" rounded-0 text-white bg-[#A4B792] hover:bg-[#889979] 
             text-white focus:outline-none font-BonaNovabold px-5 py-2 text-center me-2 mb-2 block w-[100%]"
                >
                  {bt ? "Send OTP" : "Requesting..."}
                </button>
              </form>

              <div className="mt-4 text-center">
                <Link
                  to="/login"
                  onClick={VerificationShow}
                  className="text-[13px] font-Montserratmedium text-[#2B2B2B] mb-1"
                >
                  <span className="text-[13px] font-Montserratmedium text-[#2B2B2B] mb-1">
                    Back to{" "}
                  </span>{" "}
                  Login?
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div className="md:w-6/12 w-full hidden h-screen md:block">
          <SignupSlider />
        </div>
</div>
      {/* verification */}
      <Modal size="sm" centered show={verification} onHide={handleClose}>
        <Modal.Body className="p-0">
          <Link
            to="/login"
            className="card common_box px-3 py-4 text-center text-stone-950 hover:text-stone-800"
          >
            <p className="text-xl font-semibold mb-0">
              A verification link has been sent to your registered email ID
            </p>
          </Link>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ForgotPassword;
